import { Box, Text } from '@pancakeswap/uikit'
import { PredictionUser } from 'state/types'
import styled from 'styled-components'
import { useTranslation } from '@pancakeswap/localization'
import { NetWinningsRow, Row } from './styles'
import ResultAvatar from './ResultAvatar'

interface MobileRowProps {
  rank?: number
  user: PredictionUser
  bg?: string
}

const StyledMobileRow = styled(Box)`
  background: #191b2e;
  border-radius: 16px;
  padding: 24px;
  &:not(:first-child) {
    margin-top: 24px;
    @media screen and (max-width: 700px) {
      margin-top: 16px;
    }
    /* border-top: 1px solid ${({ theme }) => theme.colors.white10}; */
  }
  @media screen and (max-width: 700px) {
    padding: 16px;
  }
`

const MobileRow: React.FC<React.PropsWithChildren<MobileRowProps>> = ({ rank, user, bg }) => {
  const { t } = useTranslation()

  return (
    <StyledMobileRow style={{ background: bg }}>
      <Row mb="8px">
        {rank ? <Text fontWeight="700">{`#${rank}`}</Text> : <div />}
        <ResultAvatar user={user} />
      </Row>
      <Row mb="8px">
        <Text fontSize="14px" color="white60">
          {t('Win Rate')}
        </Text>
        <Text fontWeight="bold">
          {`${Number(
            user.winRate.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 1 }),
          )?.toFixed(2)}%`}
        </Text>
      </Row>
      {/* <NetWinningsRow amount={user.netBNB} /> */}
      <NetWinningsRow amount={user.netETH} />
      <Row>
        <Text fontSize="14px" color="white60">
          {t('Rounds Won')}
        </Text>
        <Text fontWeight="bold">{`${user.totalBetsClaimed.toLocaleString()}/${user.totalBets.toLocaleString()}`}</Text>
      </Row>
    </StyledMobileRow>
  )
}

export default MobileRow
